import { create } from '@bufbuild/protobuf'
import type { ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { getBiddingIntradayOrder } from '@ebalance/proto/bffuser/v1/bidding_intraday_service-BiddingIntradayService_connectquery'
import {
  GetBiddingIntradayOrderRequestSchema,
  type GetBiddingIntradayOrderResponse,
} from '@ebalance/proto/bffuser/v1/bidding_intraday_service_pb'
import type { UseQueryResult } from '@tanstack/react-query'

/**
 * 時間前注文 1 件取得 hook。
 * id が空文字の場合は enabled: false でクエリをスキップする。
 * global QueryClient の `throwOnError: true` を本 query だけ `false` に上書きし、
 * 取得失敗時はページ全体を ErrorBoundary に落とさず詳細モーダル内の Alert で表示する
 * (= 一覧へ戻れる状態を保つ)。
 */
export function useGetBiddingIntradayOrder(
  id: string,
): UseQueryResult<GetBiddingIntradayOrderResponse, ConnectError> {
  return useQuery(
    getBiddingIntradayOrder,
    create(GetBiddingIntradayOrderRequestSchema, { id }),
    { enabled: id !== '', throwOnError: false },
  )
}
